export default "__VITE_ASSET__CY52kkmC__"